import autobind from 'autobind-decorator';
import { extendObservable, computed } from 'mobx';

@autobind
class BaseballMatchLineupPitcherModel {
  location;

  constructor(data, location) {
    extendObservable(this, data);

    this.location = location;
  }

  @computed
  get name() {
    const { player } = this;

    return player.displayName;
  }
}

export default BaseballMatchLineupPitcherModel;
